import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import './Home.css'
import { useSettings, resetSettings, useLoaded } from 'Settings'
import ExportJson from 'Export/ExportJson'
import ExportC, { regValues, row_content } from 'Export/ExportC'
import LegacyExport from 'Export/LegacyExport'
import Import from 'Import/Import'
import AnimatedLogo from './AnimatedLogo'
import { useNavigate } from "react-router-dom"

import { TYPE } from 'configuration';

export default function Home() {
	const [settings] = useSettings()
	const [,setLoaded] = useLoaded()
	const [show, setShow] = useState(false);
	const navigate = useNavigate()

	const handleShow = () => setShow(true)
	const handleClose = () => setShow(false)

	const handleNew = () => {
		resetSettings(settings)
		navigate('/block-diagram/')
		regValues(settings, row_content)
		setLoaded(row_content)
	}

	return (
		<div className="container home">
			<div className="overview">
				<div className="controls">
					<button
						onClick={handleNew}
						className="btn mb-3 me-3 menubtn"
						>
						<span>New</span>
						<i className="bi bi-file-earmark-plus"></i>
					</button>
					<>
						<button
							className="btn mb-3 me-3 menubtn"
							onClick={handleShow}
							>
							<span>Save</span>
							<i className="bi bi-download"></i>
						</button>
						<Modal show={show} onHide={handleClose}>
							<Modal.Header>
								<Modal.Title>Export</Modal.Title>
								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
							</Modal.Header>
							<Modal.Body>
								<ExportJson
									className="btn me-2"
									onClick={handleClose}
								/>
								<ExportC
									className="btn me-2"
									onClick={handleClose}
								/>
								<LegacyExport
									className="btn me-2"
									onClick={handleClose}
								/>
							</Modal.Body>
						</Modal>
					</>
					<Import />
				</div>
				<div className="logo">
					<span>{TYPE.toUpperCase()} Configurator</span>
					<AnimatedLogo />
				</div>
			</div>
		</div>
	)
}
